const SNOW_FLAKES = [
  { x: 6, y: -6, r: 1.1, delay: 0, dur: 2.8, opacity: 0.55 },
  { x: 14, y: -14, r: 0.7, delay: 0.4, dur: 3.4, opacity: 0.35 },
  { x: 22, y: -4, r: 1.4, delay: 0.9, dur: 2.6, opacity: 0.45 },
  { x: 30, y: -18, r: 0.9, delay: 0.15, dur: 3.8, opacity: 0.28 },
  { x: 38, y: -8, r: 1.2, delay: 1.2, dur: 3.0, opacity: 0.5 },
  { x: 46, y: -20, r: 0.6, delay: 0.55, dur: 3.5, opacity: 0.3 },
  { x: 54, y: -2, r: 1.0, delay: 1.6, dur: 2.4, opacity: 0.42 },
  { x: 62, y: -16, r: 1.3, delay: 0.3, dur: 3.6, opacity: 0.32 },
  { x: 70, y: -10, r: 0.8, delay: 1.0, dur: 2.9, opacity: 0.48 },
  { x: 78, y: -22, r: 1.1, delay: 0.7, dur: 3.9, opacity: 0.25 },
  { x: 86, y: -6, r: 0.9, delay: 1.4, dur: 2.7, opacity: 0.4 },
  { x: 94, y: -12, r: 1.2, delay: 0.2, dur: 3.2, opacity: 0.36 },
  { x: 10, y: -24, r: 0.7, delay: 1.8, dur: 3.1, opacity: 0.22 },
  { x: 50, y: -26, r: 1.0, delay: 2.1, dur: 3.7, opacity: 0.3 },
  { x: 74, y: -28, r: 0.8, delay: 0.85, dur: 3.3, opacity: 0.34 },
];

export default function AmbianceCoffeeAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--coffee"
      aria-hidden="true"
    >
      <span className="mode-tile__coffee-noise" />
      <svg
        className="mode-tile__snow-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {SNOW_FLAKES.map((flake, index) => (
          <circle
            key={index}
            className="mode-tile__snow-flake"
            cx={flake.x}
            cy={flake.y}
            r={flake.r}
            style={{
              opacity: flake.opacity,
              animationDelay: `${flake.delay}s`,
              animationDuration: `${flake.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
